<div class="border border-black p-3 mb-4">
	<div class="row no-gutters">
		<p class="ont-16 mb-3">Import by excel</p>
	</div>

	<div class="row">
		<div class="col-12">
			<button type="button" class="btn btn-bertazzoni black btn-block rounded-0 py-2 mb-3" (click)="download()">DOWNLOAD TEMPLATE</button>
		</div>
	</div>

	<div class="row">
		<div class="col-12">
			<input class="d-none" type="file" (change)="upload($event, content)" enctype="multipart/form-data" #hiddenfileinput />
			<button type="button" class="btn btn-bertazzoni black btn-block rounded-0 py-2" (click)="hiddenfileinput.click()">
				IMPORT FROM TEMPLATE
			</button>
		</div>
	</div>
</div>

<ng-template #content let-modal>
	<div class="modal-header">
		<h5 class="modal-title" id="">Import results</h5>
		<button type="button" class="close" aria-label="Close" (click)="modal.close()">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<div class="border p-3 mb-4">
			<p *ngIf="segnalazioni.length == 0" translate>nessuna.segnalazione</p>
			<table datatable [dtOptions]="{paging: false, searching: false}" class="row-border hover" *ngIf="segnalazioni.length > 0">
				<thead>
					<tr>
						<th>Row</th>
						<th>Product Code</th>
						<th>Report</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let segnalazione of segnalazioni" [class.excel-error]="segnalazione.isError">
						<td translate>{{segnalazione.riga | translate}}</td>
						<td translate>{{segnalazione.codice | translate}}</td>
						<td translate>{{segnalazione.message | translate}}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</ng-template>
